export const createListStore = (api) => (set, get) => ({
  selected: {},
  setSelected: (selected) => set({ selected }),

  list: [],
  columns: [],
  query: { keyword: "", page: 1, size: 10 },
  pagination: { total: 0, page: 1, size: 10 },

  apiAction: async () => {
    const { query } = get()
    const { items, pagination } = await api({ ...query })

    set({
      list: items,
      pagination
    })
  },

  updateQuery: async (query) => {
    set((state) => ({
      query: {
        ...state.query,
        ...query,
        page: query.page ?? 1
      }
    }))

    await get().apiAction()
  }
})
